module.exports = __WEBPACK_EXTERNAL_MODULE_268__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"openfl/text/Font","root":["openfl","text","Font"],"commonjs":"openfl/text/Font","commonjs2":"openfl/text/Font"}
// module id = 268
// module chunks = 0